'use client';

import { Box } from '@unity/cloud-ui';

export const List = (props) => {
  return <Box padding={0} margin={0} paddingLeft={2} {...props} />;
};
